import { NotiObj, NotiViewObj } from "utils/types/general.types";

import { logo } from "utils/assets_exports/images";
import dayjs from "dayjs";

export const notiData: NotiObj[] = [
    {
        id: "1",
        title: "test",
        message: "test",
        notiType: "All",
        media: logo,
        createDate: dayjs("2024-03-25").toString(),
        scheduleDate: dayjs(new Date(2024, 2, 26, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now"
    },
    {
        id: "2",
        title: "test 2",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs("2024-05-25").toString(),
        scheduleDate: dayjs(new Date(2024, 4, 26, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now"
    },
    {
        id: "3",
        title: "test 3",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs("2024-05-26").toString(),
        scheduleDate: dayjs(new Date(2024, 4, 27, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now"
    },
    {
        id: "4",
        title: "test 4 ",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs(new Date(2024, 4, 28)).toString(),
        scheduleDate: dayjs(new Date(2024, 4, 29, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now"
    },
    {
        id: "5",
        title: "test 5",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs(new Date(2024, 4, 29)).toString(),
        scheduleDate: dayjs(new Date(2024, 4, 29, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now"
    },
    {
        id: "6",
        title: "test 6",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs(new Date(2024, 4, 30)).toString(),
        scheduleDate: dayjs(new Date(2024, 4, 31, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now"
    },
    {
        id: "66",
        title: "test 6",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs(new Date(2024, 4, 30)).toString(),
        scheduleDate: dayjs(new Date(2024, 5, 1, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now",
        country: [
            {
                flags: {
                    png: "",
                    svg: "",
                    alt: ""
                },
                name: {
                    common: "All",
                    official: "All",
                    nativeName: {
                        ell: {
                            official: "",
                            common: ""
                        },
                        tur: {
                            official: "",
                            common: ""
                        }
                    }
                },
                cca2: "",
                cca3: ""
            }
        ],
        language: [
            {
                code: "en",
                name: "English",
                nativeName: "English"
            }
        ],
        topics: [
            { Name: "Car Sports", ParentTopicId: 1, SubTopicId: 10 },
            { Name: "Athletics", ParentTopicId: 1, SubTopicId: 11 },
            { Name: "Rugby", ParentTopicId: 1, SubTopicId: 12 },
            { Name: "Boxing", ParentTopicId: 1, SubTopicId: 13 },
            { Name: "Hockey", ParentTopicId: 1, SubTopicId: 14 }
        ]
    },
    {
        id: "7",
        title: "test 7",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis maiores corrupti neque facere doloremque dolorem.",
        notiType: "All",
        media: logo,
        createDate: dayjs(new Date(2024, 4, 30)).toString(),
        scheduleDate: dayjs(new Date(2024, 5, 8, 10, 30, 0)).toString(),
        status: "sent",
        reminder: "Now",
        country: [
            {
                flags: {
                    png: "",
                    svg: "",
                    alt: ""
                },
                name: {
                    common: "All",
                    official: "All",
                    nativeName: {
                        ell: {
                            official: "",
                            common: ""
                        },
                        tur: {
                            official: "",
                            common: ""
                        }
                    }
                },
                cca2: "",
                cca3: ""
            }
        ],
        language: [
            {
                code: "en",
                name: "English",
                nativeName: "English"
            }
        ],
        topics: [
            { Name: "Car Sports", ParentTopicId: 1, SubTopicId: 10 },
            { Name: "Athletics", ParentTopicId: 1, SubTopicId: 11 },
            { Name: "Rugby", ParentTopicId: 1, SubTopicId: 12 },
            { Name: "Boxing", ParentTopicId: 1, SubTopicId: 13 },
            { Name: "Hockey", ParentTopicId: 1, SubTopicId: 14 }
        ]
    }
];

export const notiViewData: NotiViewObj[] = [
    {
        id: "1",
        user: {
            id: 1,
            userName: "demo 1"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "2",
        user: {
            id: 2,
            userName: "demo 2"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "3",
        user: {
            id: 3,
            userName: "demo 3"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "4",
        user: {
            id: 4,
            userName: "demo 4"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "5",
        user: {
            id: 5,
            userName: "demo 5"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "6",
        user: {
            id: 6,
            userName: "demo 6"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "7",
        user: {
            id: 7,
            userName: "demo 7"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "8",
        user: {
            id: 8,
            userName: "demo 8"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "9",
        user: {
            id: 9,
            userName: "demo 9"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "10",
        user: {
            id: 10,
            userName: "demo 10"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "11",
        user: {
            id: 11,
            userName: "demo 11"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "12",
        user: {
            id: 12,
            userName: "demo 12"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "13",
        user: {
            id: 13,
            userName: "demo 13"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "14",
        user: {
            id: 14,
            userName: "demo 14"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "15",
        user: {
            id: 15,
            userName: "demo 15"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "16",
        user: {
            id: 16,
            userName: "demo 16"
        },
        media: logo,
        status: "sent"
    },
    {
        id: "17",
        user: {
            id: 17,
            userName: "demo 17"
        },
        media: logo,
        status: "viewed"
    },
    {
        id: "18",
        user: {
            id: 18,
            userName: "demo 18"
        },
        media: logo,
        status: "sent"
    }
];

/*
,{
    id: "1",
    user: {
        id: 1,
        userName: "demo 1"
    },
    media: logo,
    status: "sent"
}
*/
